import React, { useEffect, useState } from 'react';
import CmtCard from 'components/@coremat/CmtCard';
import CmtCardHeader from 'components/@coremat/CmtCard/CmtCardHeader';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CmtCardContent from 'components/@coremat/CmtCard/CmtCardContent';
import Box from '@material-ui/core/Box';
import { getDateElements, getNewDate,  isToday } from '../../../../components/@jumbo/utils/dateHelper';
import CustomScrollbars from "./CustomAttGoraScrollbar";
import IconButton from '@material-ui/core/IconButton';
import CmtList from 'components/@coremat/CmtList';
import EventItem from './EventItem';
import { getToDoListByUser,getMoteByID,getCurrentTodo } from 'actions'
import {useDispatch, useSelector} from 'react-redux'
// import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from '@material-ui/core/Button';
import useStyles from './index.style';
//import Typography from '@material-ui/core/Typography';
import {history} from 'store'
import {isEmpty} from 'lodash'
import moment from 'moment-timezone'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';



const CalendarEvents = (props) => {
  const dispatch = useDispatch()

  const currentAccount = useSelector(state => state.accountsData.currentAccount)
  const authUser = useSelector(state => state.auth.authUser)
  const AttgoraList = useSelector(state => state.Intranet.AttgoraList)
const locale = useSelector((state) => state.settings.locale.locale);
  const [dateCounter, setDateCounter] = useState(0);
  const [date, setDate] = useState(getNewDate(dateCounter,locale, 'DD MMM, YYYY, HH:mm'));
  const [showAll, setShowAll] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setDate(getNewDate(dateCounter,locale, 'DD MMM, YYYY, HH:mm'));
  }, [dateCounter]);

  useEffect(() => {
    dispatch(getToDoListByUser(authUser.user_id, authUser.user_Afid))
  },[])

  const GotoAktivitet=(row)=>{
    history.push({
        pathname: '/app/Aktiviteter'
      })
    //get Aktivitet
    dispatch(getCurrentTodo(currentAccount.id, authUser.user_id, row.EventId))
    // this.props.getCurrentTodo(Afid, userid, row.EventId)
  }
  const GotoMote=(row)=>{
      dispatch(getMoteByID(row.Orgnr, currentAccount.id, authUser.user_id, row.EventId))
      // this.props.getMoteByID(row.Orgnr, Afid, userid, row.EventId)
  }
  const goToAttGora = (row, ismote) => {
    if(parseInt(row.ismote) === 1) GotoMote(row)
    else GotoAktivitet(row)
  }

  const createData = () => {
    if(isEmpty(AttgoraList)) return []
    else {
      return AttgoraList.map(AG => {
        return {
          ...AG,
          id: 134,
          event_name: parseInt(AG.ismote) === 0 ? `${(AG.type === "0" ? '' : AG.type)}` : `${AG.type}`,
          color: '#FF8C00',
          isAttended: false,
          scheduled_with: { id: 12, name: AG.AF_kundnamn },
          date: moment(AG.starttime),
          startdate: moment(AG.startdate),
          Mtype:AG.Mtype,
          ismote: parseInt(AG.ismote)
        }
      })
    }
  }
  console.log(AttgoraList,"AttgoraList")
  const getHeader = () => {
    const dateObj = getDateElements(date,locale);
    return (
      <Box display="flex" flexDirection="column">
        <Box display="flex" color="common.white" alignItems="baseline">
          <Box component="span" mr={2} fontSize={{ xs: 26, md: 36, xl: 48 }} lineHeight={1} fontWeight="fontWeightBold">
            {dateObj.date.date}
          </Box>
          <Box component="span" fontSize={16}>
            {dateObj.time}
          </Box>
        </Box>
        <Box display="flex" mt={1} color="common.white">
          <Box mr={1}>{dateObj.day},</Box>
          <Box>{dateObj.date.month + ' ' + dateObj.date.year}</Box>
        </Box>
      </Box>
    );
  };

  const handleSetDateCounter = (v) => {
    setShowAll(false)
    setDateCounter(v)
  } 

  const getEvents = () => {
    return createData().filter(item => moment(date).diff(item.date, 'days') <= 7);
  };

  const showDate = () => {
    if(showAll) return <IntlMessages id="All"/>
    return isToday(date,locale) ? <IntlMessages id="Today"/> : getDateElements(date,locale).date.dateString;
  };

  const headerTitle = (task, index) => {
    return (
      <Box
        key={index}
        pl={0}
        pb={1}
        pt={1}
        fontSize={10}
        className={classes.title}>
        {task.title}
      </Box>
    );
  }
  const getHeaderTitle = task => {
    let AktiDate = new Date(`${moment(new Date(task.starttime).toLocaleString("sv-SE")).tz("Europe/Stockholm").format('YYYY-MM-DD')}T${
      moment(new Date(task.starttime).toLocaleString("sv-SE")).tz("Europe/Stockholm").format("HH:mm")
    }Z`)
    let date1 = moment(date).format("YYYY-MM-DD") ===  moment().format("YYYY-MM-DD") ?moment(date).format("YYYY-MM-DD HH:mm:ss"):moment(date).format("YYYY-MM-DD HH:mm:ss")
    const difference = moment(date1).diff(parseInt(task.ismote) === 1?task.starttime:AktiDate, 'seconds');
    const differenceDays = moment(task.starttime).startOf('day').diff(moment().startOf('day'), 'days');
    if (difference < 0) {
      if(differenceDays === 0) {
        return moment().diff(task.starttime, 'days') === 0 ? props.intl.formatMessage({ id: 'Today' }) : ` ${moment(date1).format('DD')} ${moment(date1).format('MMM')}`
      }
      return props.intl.formatMessage({ id: 'Activities.status.option1' })
    } else {  
      return props.intl.formatMessage({ id: 'Passed' })
     }
  };
  const generateHeaderList = (showList) => {

    let tasks = showAll ? createData() : getEvents()

    if (tasks.length === 0) {
      return [];
    }
    let taskListWithHeader = [];

    let currentHeaderTitle = getHeaderTitle(tasks[0]);
    let headerTitle = currentHeaderTitle;
    taskListWithHeader = [{ id: 'header-0', header: true, title: headerTitle }];

		if(!showList) tasks = tasks.splice(0, 50)

    tasks.map(task => {
      currentHeaderTitle = getHeaderTitle(task);
      if (headerTitle !== currentHeaderTitle) {
        taskListWithHeader = taskListWithHeader.concat({
          id: 'header-' + taskListWithHeader.length,
          header: true,
          title: currentHeaderTitle,
        });
        headerTitle = currentHeaderTitle;
      }
      taskListWithHeader = taskListWithHeader.concat(task);

      return task;
    });
    return taskListWithHeader;
  };

  return (
    <CmtCard className={classes.cardRoot} style={{height: 'unset',
    boxShadow: "none",
    background: "initial"
    }} elevation={3}>
      <CmtCardHeader
        className={classes.cardHeader}
        title={getHeader()}
        backgroundColor={['rgba(12,150,156,1)', 'rgba(125,106,154,1)']}>
        <Box display="flex" alignItems="center" alignSelf={"end"} color="common.white" mt={-5}>
          <IconButton className={classes.iconBtn} size="small" onClick={() => handleSetDateCounter(dateCounter - 1)}>
            <ChevronLeftIcon />
          </IconButton>
          <Box component="span" mx={2} onClick={() => handleSetDateCounter(0)} className="pointer">
          <IntlMessages id="Today"/>
          </Box>
          <IconButton className={classes.iconBtn} size="small" onClick={() => handleSetDateCounter(dateCounter + 1)}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </CmtCardHeader>
      <CmtCardContent className={classes.cardContent}>
        {/* <Typography className={classes.eventTitle}>{showDate()}</Typography> */}
        <CustomScrollbars 
        // className={classes.scrollbarRoot}
        >
          <CmtList 
            data={generateHeaderList(showAll)} 
            renderRow={(data, index) => {
              if (data.header) {
                return headerTitle(data, index);
              } else {
                return <EventItem goToAttGora={goToAttGora}  item={data} key={index} />;
              }
            }} />
        </CustomScrollbars>
        <Box display="flex" alignItems="center" mt={1}>
          <Button color="primary" className={classes.btnRoot} onClick={() => setShowAll(!showAll)}>
            {!showAll?<IntlMessages id="Show.All"/>:<IntlMessages id="Hide.All"/>}
          </Button>
        </Box>
      </CmtCardContent>
    </CmtCard>
  );
};

export default injectIntl(CalendarEvents);
